(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Handle Product Recommendation button click
  document.addEventListener('DOMContentLoaded', function() {
    // Handle Custom Search Bar button click - toggle search bar visibility
    const customSearchBarButton = document.querySelector('.app-button[data-app="custom-search-bar"]');

    if (customSearchBarButton) {
      var shouldShowSearchBar = sessionStorage.getItem('showCustomSearchBar') === 'true';
      var searchBarOriginalParent = null;
      var searchBarOriginalNext = null;
      var searchBarOriginalSection = null;

      var overlayWrapper = null;

      function toggleSearchBar(show) {
        var el = document.querySelector('.ryzo-search-bar-container');
        if (show) {
          document.body.classList.add('ryzo-custom-searchbar-visible');
          customSearchBarButton.classList.add('selected');
          customSearchBarButton.setAttribute('aria-pressed', 'true');
          if (el) {
            var banner = document.querySelector('.banner');
            if (banner) {
              if (!searchBarOriginalParent) {
                searchBarOriginalParent = el.parentNode;
                searchBarOriginalNext = el.nextSibling;
                searchBarOriginalSection = el.closest('.shopify-section');
              }
              if (!overlayWrapper) {
                overlayWrapper = document.createElement('div');
                overlayWrapper.className = 'ryzo-searchbar-banner-overlay';
              }
              overlayWrapper.appendChild(el);
              banner.style.position = 'relative';
              banner.appendChild(overlayWrapper);
              if (searchBarOriginalSection && !searchBarOriginalSection.contains(el)) {
                searchBarOriginalSection.style.display = 'none';
              }
            }
          }
        } else {
          document.body.classList.remove('ryzo-custom-searchbar-visible');
          customSearchBarButton.classList.remove('selected');
          customSearchBarButton.setAttribute('aria-pressed', 'false');
          if (el && searchBarOriginalParent) {
            if (searchBarOriginalNext) {
              searchBarOriginalParent.insertBefore(el, searchBarOriginalNext);
            } else {
              searchBarOriginalParent.appendChild(el);
            }
            if (overlayWrapper && overlayWrapper.parentNode) {
              overlayWrapper.parentNode.removeChild(overlayWrapper);
            }
            if (searchBarOriginalSection) searchBarOriginalSection.style.display = '';
          }
        }
      }

      toggleSearchBar(shouldShowSearchBar);

      // Handle button click
      customSearchBarButton.addEventListener('click', function() {
        const isCurrentlyVisible = sessionStorage.getItem('showCustomSearchBar') === 'true';
        const newState = !isCurrentlyVisible;
        const isHomePage = window.location.pathname === '/' || window.location.pathname === '';

        sessionStorage.setItem('showCustomSearchBar', newState.toString());

        if (!isHomePage && newState) {
          window.location.href = 'https://ryzo-shop.myshopify.com/';
          return;
        }

        toggleSearchBar(newState);
      });
    }

    const productRecommendationButton = document.querySelector('.app-button[data-app="product-recommendation"]');

    if (productRecommendationButton) {
      productRecommendationButton.addEventListener('click', function() {
        const productUrl = window.location.origin + '/products/converse-unisex-child-chuck-taylor-stars-sneaker?pid=9869452312877';
        // Set a flag in sessionStorage to indicate we should scroll after navigation
        sessionStorage.setItem('scrollAfterLoad', 'true');
        window.location.href = productUrl;
      });
    }

    // Handle In Bar Image Search button click - toggle visibility of searchbar image button
    const inBarImageSearchButton = document.querySelector('.app-button[data-app="in-bar-image-search"]');

    if (inBarImageSearchButton) {
      const inBarImageVisible = sessionStorage.getItem('showInBarImageSearch') === 'true';
      if (inBarImageVisible) {
        document.body.classList.add('ryzo-in-bar-image-visible');
        inBarImageSearchButton.classList.add('selected');
        inBarImageSearchButton.setAttribute('aria-pressed', 'true');
      }

      inBarImageSearchButton.addEventListener('click', function() {
        const isVisible = document.body.classList.toggle('ryzo-in-bar-image-visible');
        sessionStorage.setItem('showInBarImageSearch', isVisible.toString());
        inBarImageSearchButton.classList.toggle('selected', isVisible);
        inBarImageSearchButton.setAttribute('aria-pressed', isVisible.toString());

        if (isVisible) {
          // Wait for the VISIBLE in-bar button (there may be multiple in DOM; pick the one with non-zero size)
          var checkCount = 0;
          var maxChecks = 50;
          var checkInterval = setInterval(function() {
            checkCount++;
            // All in-bar image search buttons (custom search bar + default/header search bar). Exclude float.
            var allImageBtns = document.querySelectorAll('.ryzo-image-search-button');
            var candidates = [];
            for (var i = 0; i < allImageBtns.length; i++) {
              if (!allImageBtns[i].closest('.ryzo-image-search-container')) {
                candidates.push(allImageBtns[i]);
              }
            }
            var inBarBtn = null;
            for (var i = 0; i < candidates.length; i++) {
              var r = candidates[i].getBoundingClientRect();
              if (r.width > 0 && r.height > 0) {
                inBarBtn = candidates[i];
                break;
              }
            }
            if (inBarBtn) {
              clearInterval(checkInterval);
              var visibleButtons = [];
              for (var j = 0; j < candidates.length; j++) {
                var r2 = candidates[j].getBoundingClientRect();
                if (r2.width > 0 && r2.height > 0) visibleButtons.push(candidates[j]);
              }
              if (visibleButtons.length > 0) {
                visibleButtons[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                setTimeout(function() {
                  document.querySelectorAll('.ryzo-search-tooltip').forEach(function(t) { t.remove(); });
                  for (var k = 0; k < visibleButtons.length; k++) {
                    showTooltip(visibleButtons[k], 'Click to upload an image for search', 'below', true);
                  }
                  setTimeout(function() {
                    if (visibleButtons[0]) {
                      simulatePress(visibleButtons[0], function() {
                        visibleButtons[0].dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
                      });
                    }
                  }, 1600);
                }, 1200);
              }
            } else if (checkCount >= maxChecks) {
              clearInterval(checkInterval);
              console.log('In-bar image search: no visible button after', maxChecks, 'checks. Candidates:', candidates.length);
            }
          }, 200);
        }
      });
    }

    // Function to show tooltip next to a container (position: 'left' or 'below')
    // appendOnly: if true, do not remove existing tooltips (for showing multiple at once)
    function showTooltip(container, message, position, appendOnly) {
      position = position || 'left';
      if (!appendOnly) {
        const existingTooltips = document.querySelectorAll('.ryzo-search-tooltip');
        existingTooltips.forEach(tooltip => tooltip.remove());
      }

      if (!container || !container.getBoundingClientRect) {
        console.warn('Container not found for tooltip');
        return;
      }

      // Create tooltip element
      const tooltip = document.createElement('div');
      tooltip.className = 'ryzo-search-tooltip';
      tooltip.textContent = message;

      tooltip.classList.add(position);

      // Read rect right before positioning (after scroll/visibility changes)
      var containerRect = container.getBoundingClientRect();

      if (position === 'below') {
        tooltip.style.top = (containerRect.bottom + 12) + 'px';
        tooltip.style.left = (containerRect.left + (containerRect.width / 2)) + 'px';
      } else {
        // left: position on the left side of the container
        tooltip.style.top = (containerRect.top + (containerRect.height / 2)) + 'px';
        var tooltipWidth = 280;
        tooltip.style.left = (containerRect.left - tooltipWidth - 30) + 'px';
      }

      // Add to body
      document.body.appendChild(tooltip);

      // Trigger animation
      setTimeout(() => {
        tooltip.classList.add('show');
      }, 10);

      // Remove tooltip after 5 seconds
      setTimeout(() => {
        tooltip.classList.remove('show');
        setTimeout(() => {
          if (tooltip.parentNode) {
            tooltip.remove();
          }
        }, 300);
      }, 5000);

      // Also remove on click anywhere
      const removeTooltip = () => {
        tooltip.classList.remove('show');
        setTimeout(() => {
          if (tooltip.parentNode) {
            tooltip.remove();
          }
        }, 300);
        document.removeEventListener('click', removeTooltip);
      };
      setTimeout(() => {
        document.addEventListener('click', removeTooltip);
      }, 100);
    }

    function simulatePress(el, callback) {
      var orig = el.style.transition;
      var origTransform = el.style.transform;
      var origOpacity = el.style.opacity;
      el.style.transition = 'transform 0.18s ease, opacity 0.18s ease';
      el.style.transform = 'scale(0.88)';
      el.style.opacity = '0.55';
      setTimeout(function() {
        el.style.transform = origTransform || '';
        el.style.opacity = origOpacity || '';
        setTimeout(function() {
          el.style.transition = orig || '';
          if (callback) setTimeout(callback, 500);
        }, 150);
      }, 200);
    }

    function triggerFloatImageSearchJourney(options) {
      options = options || {};
      const container = document.querySelector('.ryzo-image-search-container');
      if (!container) {
        if (!options.silent) console.warn('Float image search container not found');
        return false;
      }

      var btn = container.querySelector('button') ||
        container.querySelector('[role="button"]') ||
        container.querySelector('.ryzo-image-search-button') ||
        document.querySelector('#float-image-icon');

      if (!btn) {
        if (!options.silent) console.warn('Float image search button not found');
        return false;
      }

      container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => {
        showTooltip(container, 'This float Image search - you can try it by clicking on it');
        setTimeout(function() {
          simulatePress(btn, function() {
            btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
            if (typeof options.onClick === 'function') options.onClick();
          });
        }, 1600);
      }, 1000);
      return true;
    }

    function autoStartDemoFloatImageSearch() {
      var demoShop = new URLSearchParams(window.location.search).get('demo_shop');
      if (!demoShop) return;
      if (window.__ryzoDemoFloatImageAutoClickInstalled) return;

      window.__ryzoDemoFloatImageAutoClickInstalled = true;

      var attempts = 0;
      var maxAttempts = 120;
      var checkInterval = setInterval(function() {
        attempts++;
        var btn = document.querySelector('.ryzo-image-search-container #float-image-icon.ryzo-image-search-button') ||
          document.querySelector('#float-image-icon.ryzo-image-search-button') ||
          document.querySelector('.ryzo-image-search-container .ryzo-image-search-button');
        var container = btn ? btn.closest('.ryzo-image-search-container') : null;
        var rect = btn ? btn.getBoundingClientRect() : null;
        var ready = btn &&
          !btn.disabled &&
          rect.width > 0 &&
          rect.height > 0 &&
          (!container || container.getBoundingClientRect().width > 0) &&
          btn.getAttribute('data-listener-added') === 'true';

        if (ready) {
          clearInterval(checkInterval);
          if (window.__ryzoDemoFloatImageAutoClicked) return;
          window.__ryzoDemoFloatImageAutoClicked = true;
          (container || btn).scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function() {
            var liveBtn = document.querySelector('.ryzo-image-search-container #float-image-icon.ryzo-image-search-button') || btn;
            liveBtn.click();
          }, 600);
        } else if (attempts >= maxAttempts) {
          clearInterval(checkInterval);
          console.warn('Demo float image search auto-start: #float-image-icon was not ready after', maxAttempts, 'checks.');
        }
      }, 250);
    }

    // Handle Float Image Search button click
    const floatImageSearchButton = document.querySelector('.app-button[data-app="float-image-search"]');

    if (floatImageSearchButton) {
      floatImageSearchButton.addEventListener('click', function() {
        triggerFloatImageSearchJourney();
      });
    }
    autoStartDemoFloatImageSearch();

    // Handle Float Text Search button click
    const floatTextSearchButton = document.querySelector('.app-button[data-app="float-text-search"]');

    if (floatTextSearchButton) {
      floatTextSearchButton.addEventListener('click', function() {
        const container = document.querySelector('.ryzo-text-search-container');
        if (container) {
          container.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(() => {
            showTooltip(container, 'This float Text search - you can try it by clicking on it');
            setTimeout(function() {
              // Strip URL query params so the Vue app starts with an empty
              // search and Flow C's full onboarding journey can replay.
              var savedSearch = window.location.search;
              if (savedSearch && /[?&]q=/.test(savedSearch)) {
                history.replaceState(null, '', window.location.pathname);
                setTimeout(function() {
                  history.replaceState(null, '', window.location.pathname + savedSearch);
                }, 10000);
              }

              // Destroy any Vue app pre-mounted at #vue-app-float during
              // page load (happens on search-results pages where another
              // script evaluates the Vue bundle and mounts everywhere).
              var floatMount = document.getElementById('vue-app-float');
              if (floatMount) floatMount.innerHTML = '';

              var btn = container.querySelector('button');
              if (btn) {
                simulatePress(btn, function() {
                  btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
                });
              }
            }, 1600);
          }, 1000);
        } else {
          console.warn('Float text search container not found');
        }
      });
    }

    // Handle Text Search button click
    const textSearchButton = document.querySelector('.app-button[data-app="text-search"]');

    if (textSearchButton) {
      textSearchButton.addEventListener('click', function() {
        var searchInput = document.querySelector('.desktop-search .search__input.field__input') ||
                           document.querySelector('.search__input.field__input') ||
                           document.querySelector('input[type="search"]');

        if (searchInput) {
          searchInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function() {
            showTooltip(searchInput, 'Type to see instant results \u2022 Press Enter for full search page');

            var nativeSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
            var query = 'gla';
            var ci = 0;
            setTimeout(function() {
              searchInput.focus();
              searchInput.dispatchEvent(new Event('focus', { bubbles: true }));
              var typer = setInterval(function() {
                if (ci < query.length) {
                  ci++;
                  nativeSetter.call(searchInput, query.substring(0, ci));
                  searchInput.dispatchEvent(new Event('input', { bubbles: true }));
                } else {
                  clearInterval(typer); typer = null;
                  instantResultsOnboard(searchInput);
                }
              }, 120);
              setTimeout(function() {
                document.addEventListener('click', function _td(e) {
                  if (!e.isTrusted) return;
                  document.removeEventListener('click', _td);
                  if (typer) { clearInterval(typer); typer = null; }
                });
              }, 600);
            }, 1600);
          }, 1000);
        } else {
          console.warn('Text search input not found');
        }
      });
    }

    var irActive = false;
    var irDismissHandler = null;

    function irGetModal() {
      return document.querySelector('.ryzo-suggestion-modal.visible');
    }

    function irGetBox(modal) {
      return modal ? modal.querySelector('.ryzo-suggestion-box') : null;
    }

    function irFullCleanup() {
      irActive = false;
      if (irDismissHandler) {
        document.removeEventListener('click', irDismissHandler);
        irDismissHandler = null;
      }
      var modal = irGetModal();
      if (modal) {
        irCleanTips(modal);
        var box = irGetBox(modal);
        if (box) {
          ['ryzo-query-suggestions-section','ryzo-collections-section','ryzo-products-section'].forEach(function(cls) {
            var s = box.querySelector('.' + cls);
            if (s) irClearHighlight(s);
          });
          irRestoreOverflow(box, modal);
        }
      }
      document.querySelectorAll('.ryzo-ir-tip').forEach(function(t) { t.remove(); });
    }

    function irSetupOverflow(modal, box) {
      var computedPos = window.getComputedStyle(modal).position;
      if (computedPos === 'static') modal.style.position = 'relative';
      modal.style.overflow = 'visible';
      box.style.overflow = 'visible';
      var container = box.querySelector('.ryzo-suggestion-container');
      if (container) container.style.overflow = 'visible';
      var leftSection = box.querySelector('.ryzo-left-section');
      if (leftSection) leftSection.style.overflow = 'visible';
    }

    function instantResultsOnboard(input) {
      irFullCleanup();
      irActive = true;
      var attempts = 0;
      var poll = setInterval(function() {
        if (!irActive) { clearInterval(poll); return; }
        attempts++;
        var modal = irGetModal();
        var box = modal ? irGetBox(modal) : null;
        if (modal && box) {
          var hasSections = box.querySelector('.ryzo-query-suggestions-section') ||
                           box.querySelector('.ryzo-collections-section') ||
                           box.querySelector('.ryzo-products-section');
          if (hasSections) {
               clearInterval(poll);
               irSetupOverflow(modal, box);
               setTimeout(function() { if (irActive) irStepSuggestions(input); }, 1500);
               setTimeout(function() {
                 irDismissHandler = function(e) {
                   if (!e.isTrusted) return;
                   document.removeEventListener('click', irDismissHandler);
                   irDismissHandler = null;
                   if (irActive) irFullCleanup();
                 };
                 document.addEventListener('click', irDismissHandler);
               }, 600);
          }
        }
        if (attempts > 50) clearInterval(poll);
      }, 200);
    }

    function irMakeTip(text, el, modal) {
      var rect = el.getBoundingClientRect();
      var modalRect = modal.getBoundingClientRect();
      var tip = document.createElement('div');
      tip.className = 'ryzo-ir-tip';
      tip.textContent = text;
      tip.style.cssText = 'position:absolute;z-index:999999;background:#4f46e5;color:#fff;padding:6px 12px;border-radius:6px;font-size:13px;white-space:nowrap;box-shadow:0 2px 8px rgba(0,0,0,.2);pointer-events:none;';
      tip.style.top = (rect.top - modalRect.top - 32) + 'px';
      tip.style.left = (rect.left - modalRect.left + rect.width / 2) + 'px';
      tip.style.transform = 'translateX(-50%)';
      var arrow = document.createElement('div');
      arrow.style.cssText = 'position:absolute;top:100%;left:50%;transform:translateX(-50%);width:0;height:0;border-left:6px solid transparent;border-right:6px solid transparent;border-top:6px solid #4f46e5;';
      tip.appendChild(arrow);
      modal.appendChild(tip);
      return tip;
    }

    function irHighlight(el) {
      el.style.boxShadow = '0 0 0 1.5px rgba(79,70,229,0.5), 0 0 0 10px rgba(79,70,229,0.05)';
      el.style.borderRadius = '10px';
    }

    function irClearHighlight(el) {
      el.style.boxShadow = '';
      el.style.borderRadius = '';
    }

    function irCleanTips(modal) {
      var parent = modal || document;
      parent.querySelectorAll('.ryzo-ir-tip').forEach(function(t) { t.remove(); });
    }

    function irRestoreOverflow(box, modal) {
      modal.style.overflow = '';
      box.style.overflow = '';
      var container = box.querySelector('.ryzo-suggestion-container');
      if (container) container.style.overflow = '';
      var leftSection = box.querySelector('.ryzo-left-section');
      if (leftSection) leftSection.style.overflow = '';
    }

    function irStepSuggestions(input) {
      if (!irActive) return;
      var modal = irGetModal();
      var box = modal ? irGetBox(modal) : null;
      if (!modal || !box) return;
      irSetupOverflow(modal, box);
      var section = box.querySelector('.ryzo-query-suggestions-section');
      if (!section) { irStepCollections(input); return; }
      irHighlight(section);
      irMakeTip('Try the suggestions!', section, modal);
      setTimeout(function() {
        if (!irActive) return;
        irClearHighlight(section);
        irCleanTips(modal);
        irStepCollections(input);
      }, 7000);
    }

    function irStepCollections(input) {
      if (!irActive) return;
      var modal = irGetModal();
      var box = modal ? irGetBox(modal) : null;
      if (!modal || !box) return;
      var section = box.querySelector('.ryzo-collections-section');
      if (!section) { irStepProducts(input); return; }
      irHighlight(section);
      irMakeTip('Browse matching collections!', section, modal);
      setTimeout(function() {
        if (!irActive) return;
        irClearHighlight(section);
        irCleanTips(modal);
        irStepProducts(input);
      }, 7000);
    }

    function irStepProducts(input) {
      if (!irActive) return;
      var modal = irGetModal();
      var box = modal ? irGetBox(modal) : null;
      if (!modal || !box) return;
      var section = box.querySelector('.ryzo-products-section');
      if (!section) { irStepEnterHint(input); return; }
      irHighlight(section);
      irMakeTip('See product results!', section, modal);
      setTimeout(function() {
        if (!irActive) return;
        irClearHighlight(section);
        irCleanTips(modal);
        irStepEnterHint(input);
      }, 7000);
    }

    function irStepEnterHint(input) {
      if (!irActive) return;
      var modal = irGetModal();
      var box = modal ? irGetBox(modal) : null;
      if (box && modal) irRestoreOverflow(box, modal);
      irActive = false;
      if (irDismissHandler) {
        document.removeEventListener('click', irDismissHandler);
        irDismissHandler = null;
      }
      if (input) {
        showTooltip(input, 'Press Enter to go to search results page');
      }
    }

    if (sessionStorage.getItem('scrollAfterLoad') === 'true') {
      sessionStorage.removeItem('scrollAfterLoad');
      if (window.location.pathname.startsWith('/products/')) {
        var recomActive = true;
        var recomAttempts = 0;
        var recomPoll = setInterval(function() {
          if (!recomActive) { clearInterval(recomPoll); return; }
          recomAttempts++;
          var recomEl = document.getElementById('vue-app-recom');
          if (recomEl && recomEl.querySelector('.scroller-item')) {
            clearInterval(recomPoll);
            recomEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(function() {
              if (!recomActive) return;
              recomEl.style.outline = '1.5px solid rgba(79,70,229,0.5)';
              recomEl.style.outlineOffset = '10px';
              recomEl.style.borderRadius = '10px';
              var rect = recomEl.getBoundingClientRect();
              var tip = document.createElement('div');
              tip.className = 'ryzo-recom-tip';
              tip.textContent = 'AI-powered similar product recommendations';
              tip.style.cssText = 'position:fixed;z-index:100000;background:#4f46e5;color:#fff;padding:6px 14px;border-radius:6px;font-size:13px;white-space:nowrap;box-shadow:0 2px 8px rgba(0,0,0,.15);pointer-events:none;';
              tip.style.top = (rect.top - 36) + 'px';
              tip.style.left = (rect.left + rect.width / 2) + 'px';
              tip.style.transform = 'translateX(-50%)';
              var arrow = document.createElement('div');
              arrow.style.cssText = 'position:absolute;top:100%;left:50%;transform:translateX(-50%);width:0;height:0;border-left:6px solid transparent;border-right:6px solid transparent;border-top:6px solid #4f46e5;';
              tip.appendChild(arrow);
              document.body.appendChild(tip);

              function recomCleanup() {
                recomActive = false;
                recomEl.style.outline = '';
                recomEl.style.outlineOffset = '';
                recomEl.style.borderRadius = '';
                if (tip.parentNode) tip.remove();
              }

              setTimeout(function() {
                document.addEventListener('click', function _rd(e) {
                  if (!e.isTrusted) return;
                  document.removeEventListener('click', _rd);
                  if (recomActive) recomCleanup();
                });
              }, 600);

              setTimeout(function() {
                if (!recomActive) return;
                recomCleanup();
                var scroller = recomEl.querySelector('.horizontal-scroller');
                if (scroller) {
                  var scrollMax = scroller.scrollWidth - scroller.clientWidth;
                  if (scrollMax > 0) {
                    var scrollStart = performance.now();
                    var duration = 6000;
                    function animateScroll(now) {
                      var elapsed = now - scrollStart;
                      var progress = Math.min(elapsed / duration, 1);
                      var ease = progress < 0.5
                        ? 2 * progress * progress
                        : 1 - Math.pow(-2 * progress + 2, 2) / 2;
                      scroller.scrollLeft = ease * scrollMax;
                      if (progress < 1) requestAnimationFrame(animateScroll);
                    }
                    requestAnimationFrame(animateScroll);
                  }
                }
              }, 3000);
            }, 600);
          }
          if (recomAttempts > 80) clearInterval(recomPoll);
        }, 250);
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
